import {useCallback} from 'react';
import {copyToClipboard} from '@/utils/clipboard';
import {inApp} from '@/utils/interface';

/** React-facing clipboard adapter; the platform-specific implementation stays in utils. */
export function useClipboard() {
  const copy = useCallback((text: string) => copyToClipboard(text, inApp), []);

  return {copy};
}
